// Intent is to keep the loader file as small as possible since it can provide an indeterminate loading/progress bar
// to indicate to the user that something is happening.
// If we tried to load all of our JS files on load, even when gzipped, it can be well over 1 MB and may be very slow
// which gives a bad UX on a slower connection. This is especially evident with integrations where the Bongo app
// is embedded in an iframe and the frame appears to not be loading anything.

// ANYTHING IMPORTED DIRECTLY by this file will be bundled with the 'loader' js file.
// Everything else should be 'lazy' loaded (as seen below by the webpackMode: 'lazy') which can also take great
// advantage of code-splitting and chunk caching.
// https://webpack.js.org/guides/lazy-loading/
import React from 'react';
import ReactDOM from 'react-dom';
import '@fontsource-variable/inter';

import manifest from './assets/manifest.json';
import faviconUrl from './assets/bongo_favicon-192.ico';

import './polyfills';
import './styles.scss';

try {
  const manifestString = JSON.stringify(manifest);
  const manifestUrl = URL.createObjectURL(new Blob([manifestString], { type: 'application/json' }));
  document.getElementById('bongo-manifest-link').setAttribute('href', manifestUrl);
} catch (e) { /* Failed to generate data URL and set manifest link */ }
try {
  document.getElementById('bongo-favicon-link').setAttribute('href', faviconUrl);
} catch (e) { /* Failed to set favicon URL */ }

document.addEventListener('DOMContentLoaded', run);

const LOADER_DELAY = 1000; // Only display the loader bar if it has taken this long to fetch the rest of the app (ie. it is not cached)

function run() {
  const rootNode = document.getElementById('root');

  const delayedLoader = setTimeout(() => {
    ReactDOM.render(
      <div className='bongo-loader-container'>
        <div className='bongo-loader-bar'>
        </div>
      </div>
      , rootNode);
  }, LOADER_DELAY);

  if (isDownloadedBbbPlayer()) {
    let path = window.location.href.split("/");
    path.pop();
    path = path.join("/") + "/";

    //We need to to set it to make "import ..." file resolving work for
    //user's local file system. We need it for proper work of downloadable BBB player
    //https://webpack.js.org/guides/public-path/#on-the-fly
    __webpack_public_path__ = path; /* NOSONAR */ //eslint-disable-line
  }

  import(
    /* webpackMode: 'lazy' */
    /* webpackChunkName: 'main' */
    'Router'
  ).then((module) => {
    // clear the root node in DOM and clear the timeout (in case the Router module is downloaded & parsed before the loader was even shown)
    ReactDOM.render(null, rootNode);
    clearTimeout(delayedLoader);

    const Router = module.default;
    ReactDOM.render(<Router basename={rootNode.dataset.basename} />, rootNode);
  });
}

// Intentionally copied from domUtils.js
// We do not want the loader.js to grow as domUtils functionality is expanded
function isDownloadedBbbPlayer() {
  return !!document.querySelector("[data-path='video']");
}
